// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"b942c4b42a67694a42fb","231":"914797f56334ac4c65d9","680":"7c5b1a4867730eef4a38","691":"47a41a03670bbb3aabda","774":"ed6b38c918a7ff17da94"}[chunkId] + ".js";
};